/** Tool definitions: Income summaries, dividends and projections. */

import type { ToolDefinition } from './types.js';

export const incomeTools = {
  get_income_summary: {
    name: 'get_income_summary',
    access: 'read',
    description:
      'Get income breakdown for a tax year including dividends (qualified vs ordinary), interest, return of capital, and totals. Useful for tax planning and tracking investment income.',
    inputSchema: {
      type: 'object',
      properties: {
        taxYear: {
          type: 'number',
          description: 'Tax year to fetch income for (e.g., 2024, 2025)',
        },
      },
      required: ['taxYear'],
    },
  },
  get_dividend_history: {
    name: 'get_dividend_history',
    access: 'read',
    description:
      'Get historical dividend payment data for a stock including payment dates, amounts, frequency, and yield. Shows dividend payment history to help evaluate income-generating investments and track dividend growth over time.',
    inputSchema: {
      type: 'object',
      properties: {
        symbol: {
          type: 'string',
          description: 'Stock symbol to get dividend history for (e.g., "AAPL", "VTI", "SCHD").',
        },
      },
      required: ['symbol'],
    },
  },
  get_income_projections: {
    name: 'get_income_projections',
    access: 'read',
    description:
      'Get projected future income data including dividend projections, interest estimates, and income forecasts. Each holding reports annualIncome, average monthlyIncome/quarterlyIncome (annual/12 and annual/4 for every frequency), lastExDividendDate and estimatedNextExDividendDate (always a future date). Quarterly buckets cover the whole requested horizon and are placed by projected ex-date month.',
    inputSchema: {
      type: 'object',
      properties: {
        portfolioId: {
          type: 'string',
          description: 'Portfolio ID to project income for.',
        },
        months: {
          type: 'number',
          description: 'Number of months to project forward. Defaults to 12.',
        },
      },
      required: ['portfolioId'],
    },
  },
} satisfies Record<string, ToolDefinition>;
